import { render, staticRenderFns } from "./ProductCenterGridTws.vue?vue&type=template&id=38ab4558&scoped=true"
import script from "./ProductCenterGridTws.vue?vue&type=script&lang=js"
export * from "./ProductCenterGridTws.vue?vue&type=script&lang=js"
import style0 from "./ProductCenterGridTws.vue?vue&type=style&index=0&id=38ab4558&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ab4558",
  null
  
)

export default component.exports